var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Prop, Component } from 'vue-property-decorator';
import ExprInput from "../../../../../../lib/comps/ExprInput";
import ExprInputCompletionProvider from "../../../../../../lib/comps/ExprInput/ExprInputCompletionProvider";
import { ExprInputCompletionCSSProvider } from "../../../../../../lib/comps/CSSEditor";
import { installCodeMirrorColorWidget } from "../../../../../../lib/comps/ExprInput/addon/uicore-css-color-widget";
const cmOptions = {
  mode: {
    name: 'interopable-scss'
  }
};
/** 不完整的SCSS编辑器 提供css补全和scss高亮 TODO:格式检查 */
let SCSSEditor = class SCSSEditor extends Vue {
  constructor() {
    super(...arguments);
    this.text = '';
  }
  created() {
    this.$watch('value', text => this.text = text, {
      immediate: true
    });
  }
  handleChange(value) {
    this.text = value;
    this.$emit('change', this.text);
  }
  handleCmReady(cm) {
    installCodeMirrorColorWidget(cm, () => {
      const inputNode = this.$refs.exprInput;
      inputNode === null || inputNode === void 0 || inputNode.commitDebounced();
      inputNode === null || inputNode === void 0 || inputNode.commitDebounced.flush();
    });
    cm.addKeyMap({
      Enter: () => {
        cm.operation(() => {
          const pos = cm.getCursor();
          const lineRemain = cm.getLine(pos.line);
          if (/\s*;\s*$|^\s*$/.test(lineRemain.slice(0, pos.ch)) || !lineRemain.includes(':') || lineRemain.includes('&')) {
            cm.execCommand('newlineAndIndent');
          } else {
            cm.replaceSelection(';\n');
            cm.setCursor({
              line: pos.line + 1,
              ch: 0
            });
          }
        });
      }
    }, false);
  }
  render() {
    const h = arguments[0];
    return h(ExprInputCompletionProvider, {
      "attrs": {
        "customMethodForRaw": ExprInputCompletionCSSProvider
      }
    }, [h(ExprInput, {
      "ref": "exprInput",
      "attrs": {
        "popupTitle": "SCSS样式编辑",
        "multipleLine": true,
        "type": "interopable-string",
        "cmOptions": cmOptions,
        "value": this.text
      },
      "on": {
        "cmReady": this.handleCmReady,
        "change": this.handleChange
      }
    })]);
  }
};
__decorate([Prop({
  type: String
})], SCSSEditor.prototype, "value", void 0);
SCSSEditor = __decorate([Component({
  name: 'SCSSEditor',
  model: {
    prop: 'value',
    event: 'change'
  }
})], SCSSEditor);
export { SCSSEditor };
//# sourceMappingURL=ScssEditor.js.map
